import UserFormSearch from '@/components/user/UserFormSearch';
import UserList from '@/components/user/UserList';
import UserTopHeader from '@/components/user/UserTopHeader';
import React, { useState } from 'react';

const StudentManagementPage: React.FC = () => {
  const [uploadCsv, setUploadCsv] = useState('');
  const [searchTrigger, setSearchTrigger] = useState(0);

  return (
    <>
      <UserTopHeader setUploadCsv={setUploadCsv} />
      <UserFormSearch onSearch={() => setSearchTrigger(prev => prev + 1)} />
      <UserList uploadCsv={uploadCsv} searchTrigger={searchTrigger} />
    </>
  )
}

export default StudentManagementPage;